export default __webpack_public_path__ + "static/media/highlight_elements.e4ee6feb.gif";